module.exports = __webpack_public_path__ + "img/unfold-icon-3.0bdf0487.png";